<div class="btn-group text-left">
	<a aria-expanded="false" data-toggle="dropdown" class="btn btn-sm btn-white dropdown-toggle" type="button">
		<span class="js-selected-text">{{text}}</span> <span class="caret m-l-15"></span>
	</a>
	<ul role="menu" class="dropdown-menu">
		{{#each items}}
		<li>
			<a href="#" data-option="{{value}}" >{{text}}</a>
		</li>
		{{/each}}
	</ul>
</div>
